/**
 * デモモード関連の定数定義
 * FL-132リファクタリング: 重複定義されていた定数を統一
 */

/**
 * デモ会社ID
 * 株式会社サンプル陸送のcompanyId
 */
export const DEMO_COMPANY_ID = 'e32a0499-6456-44ac-9b16-b0001098c259' as const;

/**
 * デモモード関連の設定値
 */
export const DEMO_CONFIG = {
  COMPANY_ID: DEMO_COMPANY_ID,
  COMPANY_NAME: '株式会社サンプル陸送',
  BASE_DATE: '2025-07-22',
  VERSION: '1.0.0',
} as const;

/**
 * デモデータ統計情報
 */
export const DEMO_STATS = {
  TOTAL_CASES: 15,
  TODAY_CASES: 8,
  TRANSPORTERS: 8,
  AI_OPTIMIZATION_SCENARIOS: 1,
  WEEKLY_SCHEDULE_DAYS: 7,
} as const;
